<div class="modal-body form-modal-body">
  <div class="skylark-modal-header">
    <h4>Add link</h4>
    <button type="button" class="icon" (click)="closeModal()"><span class="pi pi-times"></span></button>
  </div>
  <div *ngIf="!siteOwners.length || !contractors.length" style="width: 50px; margin: 0 auto">
    <p-progressSpinner [style]="{ width: '50px', height: '50px' }" [strokeWidth]="4"></p-progressSpinner>
  </div>
  <form *ngIf="siteOwners.length && contractors.length">
    <div class="form-group" [formGroup]="form">
      <div class="row">
        <div class="col-md-12">
          <div class="form-group">
            <label>Contractor</label>
            <p-dropdown
              class="form-control"
              formControlName="contractor"
              [options]="contractors"
              placeholder="Select contractor..."
              required="true"
              [style]="{ width: '100%' }"
              filter="true"
            ></p-dropdown>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12">
          <div class="form-group">
            <label>Site Owner</label>
            <p-dropdown
              class="form-control"
              formControlName="siteOwner"
              [options]="siteOwners"
              placeholder="Select site owner..."
              required="true"
              [style]="{ width: '100%' }"
              filter="true"
            ></p-dropdown>
          </div>
        </div>
      </div>
    </div>
  </form>
  <p-footer>
    <button type="button" (click)="onSubmit()" [disabled]="!form.valid || !form.dirty" class="btn btn-sm btn-success">Save</button>
    <button type="button" (click)="closeModal()" class="btn btn-sm btn-default">Cancel</button>
  </p-footer>
</div>
